import moment, { type Moment } from "moment";

export const DATE_FORMAT = "DD-MM-YYYY";

/** Parse backend date strings as local wall-clock values. Use `parseServerDateTime` for UTC timestamps. */
export function parseLocalDateTime(value: string | null | undefined): Date | null {
  if (!value) return null;
  const dt = new Date(String(value).replace(/ /g, "T"));
  return Number.isNaN(dt.getTime()) ? null : dt;
}

/** Remove the Russian era suffix while preserving other localized date separators. */
export function formatDateNoEra(parts: Intl.DateTimeFormatPart[]): string {
  return parts
    .filter((part) => !(part.type === "literal" && part.value.includes("г")))
    .map((part) => part.value)
    .join("")
    .trim();

}

/** Mask date-field digits as `DD-MM-YYYY` and clamp invalid day, month and year segments. */
export function maskDdMmYyyy(value: string): string {
  const digits = value.replace(/[^0-9]/g, "");
  let dd = digits.slice(0, 2);
  let mm = digits.slice(2, 4);
  let yyyy = digits.slice(4, 8);

  if (dd.length === 2 && parseInt(dd, 10) > 31) {
    dd = "31";
  } else if (dd.length === 2 && parseInt(dd, 10) === 0) {
    dd = "01";
  }
  if (mm.length === 2 && parseInt(mm, 10) > 12) {
    mm = "12";
  } else if (mm.length === 2 && parseInt(mm, 10) === 0) {
    mm = "01";
  }
  if (yyyy.length === 4 && parseInt(yyyy, 10) < 1900) {
    yyyy = "1900";
  }

  return [dd, mm, yyyy].filter(Boolean).join("-");
}

export function formatDatetime(e: React.FocusEvent<HTMLInputElement>): void {
  e.target.value = maskDdMmYyyy(e.target.value);
}

/** Format `Month D, YYYY`; a separate month formatter preserves the Russian nominative form. */
export function formatLongDate(date: Date, locale: string): string {
  const intlLocale = locale === "ru" ? "ru-RU" : "en-US";
  const month = new Intl.DateTimeFormat(intlLocale, { month: "long" }).format(date);
  const capitalizedMonth = month.charAt(0).toUpperCase() + month.slice(1);
  return `${capitalizedMonth} ${date.getDate()}, ${date.getFullYear()}`;
}

export function formatDate(date: Date): Moment {
  const fullDate = new Date(date);
  const day = fullDate.getDate() < 10 ? `0${fullDate.getDate()}` : fullDate.getDate();
  const month = fullDate.getMonth() + 1;
  const year = fullDate.getFullYear();

  return moment(`${year}-${month}-${day}`, "YYYY-MM-DD");
}
